export default "__VITE_ASSET__CjRXDeaq__"